module.exports = {
    planimetriasData: () => {
        return [{
                "Nombre": "Sótano 1",
                "Imagen": require("./planimetria/plano-1.jpg")
            },
            {
                "Nombre": "Sótano 2",
                "Imagen": require("./planimetria/plano-2.jpg")
            },
            {
                "Nombre": "Piso 1",
                "Imagen": require("./planimetria/plano-3.jpg")
            },
            {
                "Nombre": "Piso 2",
                "Imagen": require("./planimetria/plano-4.jpg")
            },
            {
                "Nombre": "Pisos 3-8",
                "Imagen": require("./planimetria/plano-5.jpg")
            }
        ]
    }
}